
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTempHot as ObiTempHotElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-temp-hot.js';
 
 
 

 
 export const ObiTempHot = createComponent({
   react: React,
   tagName: 'obi-temp-hot',
   elementClass: ObiTempHotElement,
   events: {
     
   }
  });
 
 